import React from 'react';
import { useStatsig } from '../hooks/useStatsig';

export default (ChildComponent) => {
    const WithStatsig = (props) => {
        const { checkGate, featureGates } = useStatsig();
        return (<ChildComponent {...props} featureGates={featureGates} checkGate={checkGate} />);
    };

    WithStatsig.displayName = `WithStatsig(${ChildComponent.displayName || ChildComponent.name || 'Component'})`;

    return WithStatsig;
};
